import { getAbsoluteUrl } from '@wix/ricos-common';
var OEMBED_URL = '/rich-content/oembed?url=';
var buildUrl = function (url) { return OEMBED_URL + getAbsoluteUrl(url); };
export var fetchOembed = function (url, instance) {
    return fetch(buildUrl(url), {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: instance,
        },
    }).then(function (res) { return res.json(); });
};
//# sourceMappingURL=fetchOembed.js.map